var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocations(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0C2.01214 0 0 2.0345 0 4.55C0 5.681 0.321428 6.7405 0.906428 7.696C1.51714 8.697 2.32071 9.555 2.93786 10.556C3.24 11.0435 3.45857 11.4985 3.69 12.025C3.85714 12.3825 3.99214 13 4.5 13C5.00786 13 5.14286 12.3825 5.30357 12.025C5.54143 11.4985 5.75357 11.0435 6.05571 10.556C6.67286 9.5615 7.47643 8.7035 8.08714 7.696C8.67857 6.7405 9 5.681 9 4.55C9 2.0345 6.98786 0 4.5 0ZM4.5 6.3375C3.61286 6.3375 2.89286 5.6095 2.89286 4.7125C2.89286 3.8155 3.61286 3.0875 4.5 3.0875C5.38714 3.0875 6.10714 3.8155 6.10714 4.7125C6.10714 5.6095 5.38714 6.3375 4.5 6.3375Z",
    fill: "#FF722C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocations);
export default __webpack_public_path__ + "static/media/locations.9c5329ef0d2515d963fa09f4833754c3.svg";
export { ForwardRef as ReactComponent };